__webpack_require__.p = "https://cdn.gameon.sephora.pl/build/";